<template>
  <div>
    <header-component pageType="write"  :menuIndex="1"/>
    <div class="content1 flex flex-column flex-align-center">
      <div class="common-txt1" data-aos="fade-up">{{ $t('solution3.content1.title1') }}</div>
      <div class="txt2" data-aos="fade-up" data-aos-delay="100">{{ $t('solution3.content1.title2') }}</div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="200">{{ $t('solution3.content1.desc') }}</div>
      <div class="ty" data-aos="fade-up" data-aos-delay="300" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution3.content1.btn') }}</div>
    </div>
    <div class="content2 flex flex-column flex-align-center">
      <div class="common-txt1" data-aos="fade-up" v-html="$t('solution3.content2.title')"></div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution3.content2.desc')"></div>
      <div class="item-nav flex flex-wrap flex-justify-around">
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="200">
          <img src="@/assets/image/solution3/Slice 39@2x.png"/>
          <div class="txt" v-html="$t('solution3.content2.items.0.text')"></div>
        </div>
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="300">
          <img src="@/assets/image/solution3/Slice 39@2x(1).png"/>
          <div class="txt" v-html="$t('solution3.content2.items.1.text')"></div>
        </div>
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="400">
          <img src="@/assets/image/solution3/Slice 39@2x(2).png"/>
          <div class="txt" v-html="$t('solution3.content2.items.2.text')"></div>
        </div>
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="500">
          <img src="@/assets/image/solution3/Slice 39@2x(3).png"/>
          <div class="txt" v-html="$t('solution3.content2.items.3.text')"></div>
        </div>
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="600">
          <img src="@/assets/image/solution3/Slice 39@2x(4).png"/>
          <div class="txt" v-html="$t('solution3.content2.items.4.text')"></div>
        </div>
        <div class="item flex flex-column flex-align-center" data-aos="fade" data-aos-delay="700">
          <img src="@/assets/image/solution3/Slice 39@2x(5).png"/>
          <div class="txt" v-html="$t('solution3.content2.items.5.text')"></div>
        </div>
      </div>
    </div>
    <div class="content3 flex flex-column flex-align-center">
      <div class="common-txt1">{{ $t('solution3.content3.title') }}</div>
      <div class="item"  data-aos="fade"  data-aos-delay="100">
        <div class="title">{{ $t('solution3.content3.items.0.title') }}</div>
        <div class="desc">{{ $t('solution3.content3.items.0.desc') }}</div>
      </div>
      <div class="item" data-aos="fade" data-aos-delay="100">
        <div class="title">{{ $t('solution3.content3.items.1.title') }}</div>
        <div class="desc">{{ $t('solution3.content3.items.1.desc') }}</div>
      </div>
      <div class="item" data-aos="fade" data-aos-delay="100">
        <div class="title">{{ $t('solution3.content3.items.2.title') }}</div>
        <div class="desc">{{ $t('solution3.content3.items.2.desc') }}</div>
      </div>
    </div>
    <connect-component ref="connectRef" @kf="$refs.connectRef.toConnectIndex()"></connect-component>
    <kf-component kf-top="1086px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution1-page',
  data() {
    return {
      
    }
  }
}
</script>
<style lang="less" scoped>
.common-txt1 {
  color: #000000;
  font-size: 60px;
  line-height: 90px;
  font-weight: bold;
  text-align: center;
}

.common-txt3 {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 20px;
  color: #979797;
  line-height: 30px;
  width: 651px;
  text-align: center;
  margin-top: 20px;
}

.content1 {
  width: 1242px;
  min-height: 979px;
  margin: 111px auto 70px;
  background: url('@/assets/image/solution3/Slice 37@2x.png') no-repeat center/100% 100%;
  .txt2 {
    color: #4947D7;
    font-size: 60px;
    line-height: 90px;
    font-weight: bold;
  }

  .ty {
    position: relative;
    width: 257px;
    height: 44px;
    line-height: 44px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    letter-spacing: 12px;
    text-align: center;
    background: #fff;
    /* 设置内部背景色 */
    border-radius: 62px;
    /* 圆角 */
    overflow: hidden;
    /* 确保伪元素不会溢出 */
    z-index: 1;
    /* 确保内容在伪元素之上 */
    margin-top: 20px;
    cursor: pointer;
  }

  .ty::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 62px;
    /* 圆角与主元素保持一致 */
    padding: 2px;
    /* 边框宽度 */
    background: linear-gradient(90deg, rgba(255, 132, 194, 1), rgba(160, 43, 254, 1));
    /* 渐变边框 */
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    /* 遮罩 */
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    /* 遮罩组合 */
    z-index: -1;
    /* 伪元素位于内容之下 */
  }
}
.content2{
  .common-txt1{
    font-size: 40px;
    line-height: 60px;
  }
  .item-nav{
    margin-top: 65px;
    width: 1000px;
    .item{
      width: 256px;
      min-height: 252px;
      padding: 20px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 7px 11px 0px rgba(0,0,0,0.04);
      border-radius: 10px 10px 10px 10px;
      margin-bottom: 60px;
      img{
        width: 131px;
        height: 131px;
      }
      .txt{
        font-family: Plus Jakarta Sans, Plus Jakarta Sans;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 26px;
        text-align: center;
      }
    }
  }
}
.content3{
  .common-txt1{
    font-size: 40px;
    line-height: 60px;
  }
  min-height: 963px;
  background: url('@/assets/image/solution3/Slice 40@2x.png') no-repeat center/cover;
  padding-top: 121px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .item{
    width: 306px;
    height: 96px;
    position: absolute;
    padding: 32px;
    
    .title{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 14px;
      color: #FFBF07;
      line-height: 17px;
      letter-spacing: 1px;
      text-indent: 20px;
      margin-bottom: 17px;
    }
    .desc{
      font-family: Roboto, Roboto;
      font-weight: 300;
      font-size: 16px;
      color: #B5A986;
      line-height: 30px;
    }
    &:nth-of-type(2) {
      top: 196px;
      left: 829px;
      .title{color: #FFBF07;}
      .desc{color: #B5A986;}
    }
    &:nth-of-type(3) {
      top: 842px;
      left: 533px;
      .title{color: #B187DF;}
      .desc{color: #838BB8;}
    }
    &:nth-of-type(4) {
      top: 888px;
      left: 1120px;
      .title{color: #3DC6D1;}
      .desc{color: #87A6A7;}
    }
  }
}
</style>